<script lang="ts">
	// shadcn-svelte Dialog.Overlay (bits-ui), RESTYLED. The scrim behind the dialog.
	// Entry/exit animations (which need tailwindcss-animate, not shipped) are dropped
	// — same call we make in select-content. NO arbitrary `[..]` values.
	import { Dialog as DialogPrimitive } from "bits-ui";
	import { cn } from "../../../utils.js";

	let {
		ref = $bindable(null),
		class: className,
		...restProps
	}: DialogPrimitive.OverlayProps = $props();
</script>

<DialogPrimitive.Overlay
	bind:ref
	data-slot="dialog-overlay"
	class={cn("fixed inset-0 z-50 bg-black/50", className)}
	{...restProps}
/>
